import { axiosGet } from "../options/header"



export default {
  getAllStatusi() {
    try {
      return axiosGet(process.env.VUE_APP_API_ENDPOINT_STARTER + "/api/osoba/statusi", {
        credentials: true
      });
    } catch (err) {
      console.log(err);
    }
  },

  getLegBodyStatusi() {
    try {
      return axiosGet(process.env.VUE_APP_API_ENDPOINT_STARTER + "/predmeti/sluzbena-uloga", {
        credentials: true
      });
    } catch {
      console.log("Failed attempt at group.");
    }
  }

}